import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CommonBindingDataService } from '../../services/common-binding-data.service';
import { formatTimeCell, getDate } from '../../utility-functions/grid';
import { MiGrid2Component } from '../mi-grid-2/mi-grid-2.component';

@Component({
  selector: 'app-upcoming-bookings',
  templateUrl: './upcoming-bookings.component.html',
  styleUrls: ['./upcoming-bookings.component.scss'],
  providers: [DatePipe]
})
export class UpcomingBookingsComponent implements OnInit {

  @ViewChild(MiGrid2Component) gridRef2: MiGrid2Component;
  @Input() driverId: any = '';
  @Input() bookingType: any = '';
  @Input() fromDate: any = '';
  @Input() toDate: any = '';
  url: any = '';
  columns: any[] = [];
  uniqId = 'upcoming_bookings';

  constructor(
    private commonBindingDataService: CommonBindingDataService,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.url = `/secure/drivers/${this.driverId}/bookinghistory?type=${this.bookingType}&fromDate=${this.fromDate}&toDate=${this.toDate}`;

    this.columns.push({
      field: 'tripId', header: this.commonBindingDataService.getLabel('label_journey_id'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.commonBindingDataService.getBookingIdwithMultiStop(i)),
    });
    this.columns.push({
      field: 'pickupDateTime', header: this.commonBindingDataService.getLabel('grid_pickup_time'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.firstCell(i)),
    });
    this.columns.push({
      field: 'estimatedDropOffTime', header: this.commonBindingDataService.getLabel('eta_dropoff_time'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.getEtaToPickupInfo(i)),
    });
    this.columns.push({
      field: 'pickupLocationName', header: this.commonBindingDataService.getLabel('grid_pickup_drop_off'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.commonBindingDataService.getPickDropLocation(i)),
    });
    this.columns.push({
      field: 'driverName', header: this.commonBindingDataService.getLabel('label_driver'),
      sort: false, resize: true
    });
    this.columns.push({
      field: 'passengerName', header: this.commonBindingDataService.getLabel('label_passenger'),
      sort: false, resize: true
    });
    this.columns.push({
      field: 'statusStr', header: this.commonBindingDataService.getLabel('label_status'),
      sort: false, resize: true, bold: true
    });
  }

  firstCell(params) {
    const eDiv = document.createElement('div');
    const lblStatus = `<div class="booking-grid-table" title="">
    <div class = "pickup-time">` + formatTimeCell(parseInt(params.pickupDatetime, 10)) + `
    </div>
    <div class = "pickup-date">` + getDate(parseInt(params.pickupDatetime, 10)) + `</div>
    </div>`;
    const mutiStop = this.commonBindingDataService.getMultipleStopDeatils(params);
    const multiVehicle = this.commonBindingDataService.getMultiVehicleDeatils(params);

    eDiv.innerHTML += lblStatus + mutiStop + multiVehicle;
    return eDiv;
  }

  getEtaToPickupInfo(params) {
    const eDiv = document.createElement('div');
    let etaInfo = `
                  <div class="mt-2">
                  <span class='eta-to-pickup'>NA</span>
                  </div>`;
    if (params.estimatedDropOffTime !== null) {
      etaInfo = `
             <div class="mt-2">
             <span class='eta-to-pickup' style="font-size: 17px;font-weight: bold;">
             ${this.datePipe.transform(params?.estimatedDropOffTime, 'H:mm')}
            </span>
            </div>`;
    }

    eDiv.innerHTML += etaInfo;
    return eDiv;
  }
}
